export const PRICE_GAP = 24;
